import React, { useState, useEffect } from "react";
import useStyles from "./style";
import {
  Typography,
  Divider,
  Grid,
  FormGroup,
  FormControlLabel,
  Switch,
  Box,
} from "@mui/material";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import CustomSwitch from "SharedComponents/CustomSwitch";
import driverApi from "../../../../../Services/Driver";

const Status = ({ onRef, driverId, setsubmitButton, setSkipButton }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    setsubmitButton(true);
    setSkipButton(true);
  }, [setsubmitButton, setSkipButton]);

  const [isEditable, setIsEditable] = useState(false);
  const [driverStatus, setDriverStatus] = useState();
  const [accountStatus, setAccountStatus] = useState();
  const [driverServiceData, setDriverServiceData] = useState([]);

  const DriverServiceDetails = () => {
    if (!driverId) return;
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDriverServiceData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch driver status details",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    driverApi.getDriverServiceDetails(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    setDriverServiceData([]);
    DriverServiceDetails();
  }, [driverId]);

  useEffect(() => {
    if (driverServiceData && Object.keys(driverServiceData).length > 0) {
      setAccountStatus(
        driverServiceData?.accountStatus === "APPROVED"
          ? "APPROVED"
          : driverServiceData?.accountStatus === "BANNED"
          ? "BANNED"
          : "ONBOARDING"
      );
      setDriverStatus(driverServiceData?.driverAccountStatus === "ACTIVE");
    }
  }, [driverServiceData]);

  const handleUpdateStates = () => {
    setDriverStatus((prev) => !prev);
  };

  const handleAccountStatus = (event) => {
    setAccountStatus(event.target.value);
  };

  const updateDriverService = () => {
    if (!driverId) return;

    const data = {
      accountStatus: accountStatus,
      driverAccountStatus: accountStatus === "BANNED" ? "DE_ACTIVE" : driverStatus ? "ACTIVE" : "DE_ACTIVE",
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Driver status updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Error while updating driver status",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    driverApi.updateDriverServiceStatus(driverId, { ...data }).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (driverStatus !== undefined || accountStatus !== undefined) {
      updateDriverService();
    }
  }, [driverStatus, accountStatus]);

  const getFormData = () => {
    return { driverStatus, accountStatus };
  };

  useEffect(() => {
    onRef && onRef(getFormData);
  }, [onRef, driverStatus, accountStatus]);

  if (accountStatus === undefined || driverStatus === undefined) {
    return <Typography sx={{ fontFamily: "'Inter', sans-serif" }}>Loading...</Typography>;
  }

  return (
    <Box sx={{ p: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography className={classes.noteText}>
          &quot; Note: Manually updating the driver status will reflect the corresponding changes in the app flow. &quot;
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={isEditable}
              onChange={(e) => setIsEditable(e.target.checked)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#10b981",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#10b981",
                },
                "& .MuiSwitch-switchBase": {
                  color: "#ef4444",
                },
                "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                  backgroundColor: "#ef4444",
                },
              }}
            />
          }
          label="Enable Edit"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              fontWeight: 500,
            },
          }}
        />
      </Box>

      <Box style={{ opacity: isEditable ? 1 : 0.6, pointerEvents: isEditable ? "auto" : "none" }}>
        <Grid container>
          {/* Account Status */}
          <Grid item xs={12} className={classes.switchWrapper}>
            <Typography variant="body1">Account Status</Typography>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={accountStatus}
                onChange={handleAccountStatus}
                disabled={!isEditable}
              >
                <FormControlLabel
                  value="ONBOARDING"
                  control={<Radio sx={{ color: "#1a1a1a", "&.Mui-checked": { color: "#1a1a1a" } }} />}
                  label="On Boarding"
                  sx={{ "& .MuiFormControlLabel-label": { fontFamily: "'Inter', sans-serif" } }}
                />
                <FormControlLabel
                  value="APPROVED"
                  control={<Radio sx={{ color: "#1a1a1a", "&.Mui-checked": { color: "#1a1a1a" } }} />}
                  label="Approve"
                  sx={{ "& .MuiFormControlLabel-label": { fontFamily: "'Inter', sans-serif" } }}
                />
                <FormControlLabel
                  value="BANNED"
                  control={<Radio sx={{ color: "#1a1a1a", "&.Mui-checked": { color: "#1a1a1a" } }} />}
                  label="Banned"
                  sx={{ "& .MuiFormControlLabel-label": { fontFamily: "'Inter', sans-serif" } }}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} className={classes.divider}>
            <Divider />
          </Grid>

          {/* Driver Status */}
          <Grid item xs={12} className={classes.switchWrapper}>
            <Typography variant="body1">Driver Status (Active/De-active)</Typography>
            <FormGroup>
              <FormControlLabel
                control={
                  <CustomSwitch
                    checked={driverStatus}
                    onChange={() => handleUpdateStates()}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#10b981",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        backgroundColor: "#10b981",
                      },
                      "& .MuiSwitch-switchBase": {
                        color: "#ef4444",
                      },
                      "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                        backgroundColor: "#ef4444",
                      },
                    }}
                  />
                }
                label=""
              />
            </FormGroup>
          </Grid>
          <Grid item xs={12} className={classes.divider}>
            <Divider />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Status;
